import React from 'react';
import styles from './ElementPlaceholder.module.scss';
/** Use in storybook to stand in for a component that is normally passed in as a prop. */ export const ElementPlaceholder = ({ caption })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.elementPlaceholder
    }, /*#__PURE__*/ React.createElement("span", {
        className: styles.caption
    }, caption));
};
